import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f9c2602"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "external-link" }

import Icon from '@/components/Icon.vue';
import { useLayout } from '@/composables/core/useLayout';


export default /*#__PURE__*/_defineComponent({
  props: {
    label: null,
    url: null,
    color: null
  },
  setup(__props: any) {

const props = __props as {
  label: string;
  url: string;
  color?: string;
}


const { openLink } = useLayout();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["inline-flex align-items-center flex-nowrap clickable", __props.color ? `text-${__props.color}` : ' text-primary']),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openLink)(__props.url)))
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(__props.label), 1),
    _createVNode(Icon, {
      name: "externalLink",
      class: "ml-s1",
      size: "16"
    })
  ], 2))
}
}

})